import { render, staticRenderFns } from "./header-info.vue?vue&type=template&id=fb2c6a18&scoped=true&"
import script from "./header-info.vue?vue&type=script&lang=ts&"
export * from "./header-info.vue?vue&type=script&lang=ts&"
import style0 from "./header-info.vue?vue&type=style&index=0&id=fb2c6a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2c6a18",
  null
  
)

export default component.exports